import { render, staticRenderFns } from "./TwismWalletEditDate.vue?vue&type=template&id=19f00b9e&scoped=true&"
import script from "./TwismWalletEditDate.vue?vue&type=script&lang=ts&"
export * from "./TwismWalletEditDate.vue?vue&type=script&lang=ts&"
import style0 from "./TwismWalletEditDate.vue?vue&type=style&index=0&id=19f00b9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f00b9e",
  null
  
)

export default component.exports